import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const useStyles = makeStyles((theme: Theme) => ({
  bodyContainer: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },

  uploadArea: {
    height: '150px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '0.25rem',
    cursor: 'pointer',
    marginBottom: '1.5rem',
    borderRadius: '0.33rem',
    border: '2px dashed #3024E1',
    backgroundColor: '#FFFFFF',
    transition: 'all 200ms ease',

    '& .MuiSvgIcon-root': {
      fontSize: '1.5rem !important',
      color: '#3024E1',
    },

    '&:hover': {
      backgroundColor: getRGBA(' #3024E1', 0.04),
    },
  },

  uploadAreaTextSend: {
    padding: '0 !important',
    margin: '0 !important',
    fontFamily: 'Nunito',
    fontSize: '1rem !important',
    fontWeight: '400 !important',
    lineHeight: '1.5rem !important',
    color: '#3024E1',
  },

  uploadAreaTextInfo: {
    fontFamily: 'Nunito',
    fontSize: '0.8rem !important',
    fontWeight: '400 !important',
    lineHeight: '1.245rem !important',
    color: getRGBA('#0F0F1E', 0.6),
  },

  uploadFileBox: {
    maxHeight: '450px',
    overflowY: 'scroll',
  },

  fileBody: {
    display: 'flex',
    flexDirection: 'column',
  },

  fileItem: {
    width: '100%',
    borderRadius: '0.5rem',
    backgroundColor: theme.palette.primary.contrastText,

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0 0.25rem',

    '& .MuiSvgIcon-root': {
      color: '#C4C4C4',
      fontSize: '2rem',
      cursor: 'pointer',
    },
  },

  fileText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1rem',
    width: '100%',

    '& span': {
      fontFamily: 'Nunito',
      fontSize: '1rem',
      fontWeiht: '400',
      lineClamp: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
    },
  },

  fileItemArticleIcon: {
    fontSize: '1.6rem !important',
    cursor: 'pointer',
    color: '#1C1B1F !important',
  },

  fileItemDeleteIcon: {
    color: '#DE3730 !important',
    fontSize: '1.6rem !important',
    cursor: 'pointer',
  },

  fileBoxRow: {
    margin: '1.5rem 0',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: '1rem',
  },

  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1rem',
    width: '100%',
    heigth: '100%',
  },

  InitialRoot: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },

  divisor: {
    width: '100%',
    height: '1px',
    backgroundColor: '#E4E4E4',
    margin: '0.75rem 0rem',
  },

  formButton: {
    height: '35px !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0rem 0.15rem !important',
    padding: '0.5rem 0rem !important',
    fontSize: '1rem !important',
  },

  fileBoxForm: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',

    '& span': {
      fontSize: '0.75rem',
      color: '#C4C4C4',
      marginTop: '0.25rem',
    },
  },

  fileBoxTextForm: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',

    '& h1': {
      fontFamily: 'Nunito !important',
      fontSize: '1rem !important',
      fontWeight: 'normal',
      lineHeight: '16px !important',
    },
  },

  inputFileTextItem: {
    width: '100% !important',
    fontSize: '14px !important',
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },

  inputFileItem: {
    width: '100% !important',
    fontSize: '14px !important',
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },

  //Button end of page
  actions: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    gap: '0.5rem',
    paddingTop: '1.5rem',
  },

  submitButton: {
    height: '2.625rem !important',
    padding: '1rem !important',
  },

  cancelButton: {
    height: '2.625rem !important',
    padding: '1rem !important',
    color: '#BA1A1A !important',
    border: `1px solid ${getRGBA('#BA1A1A', 0.5)} !important`,
  },
}))

export { useStyles }
